// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d1f995ef","455":"fe46915b","977":"fee62dc1"}[chunkId] + ".chunk.js";
};